import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { TableRow, TableCell, Skeleton } from '@mui/material';
const IsLoading = ({ rowLength, colLength }) => {
    const length = rowLength ? rowLength : 8;
    const rowsToShow = Array.from({
        length,
    }, () => {
        return {
            _id: Math.random(),
        };
    });
    return (_jsx(_Fragment, { children: rowsToShow.map((i) => (_jsx(TableRow, { children: _jsx(TableCell, Object.assign({ colSpan: colLength + 1 }, { children: _jsx(Skeleton, { variant: "rectangular", width: '100%', height: 60 }) })) }, i._id))) }));
};
export default IsLoading;
